import { render, staticRenderFns } from "./RoleEditModal.vue?vue&type=template&id=43b8ef61&scoped=true&"
import script from "./RoleEditModal.vue?vue&type=script&lang=js&"
export * from "./RoleEditModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditModal.vue?vue&type=style&index=0&id=43b8ef61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b8ef61",
  null
  
)

export default component.exports